/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Settings_Collaborators_Manageroles_Savepartialfailure3Inputs */

const en_settings_collaborators_manageroles_savepartialfailure3 = /** @type {(inputs: Settings_Collaborators_Manageroles_Savepartialfailure3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update roles for ${i?.names}`)
};

/**
* | output |
* | --- |
* | "Failed to update roles for {names}" |
*
* @param {Settings_Collaborators_Manageroles_Savepartialfailure3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_manageroles_savepartialfailure3 = /** @type {((inputs: Settings_Collaborators_Manageroles_Savepartialfailure3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Manageroles_Savepartialfailure3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_manageroles_savepartialfailure3(inputs)
});
export { settings_collaborators_manageroles_savepartialfailure3 as "settings_collaborators_manageRoles_savePartialFailure" }